theme.headerSticky = (function () {
  // Ignore sub-pixel jitter and momentum bounce so the header doesn't flicker.
  const SCROLL_DELTA = 5

  function ScrollSticky(e) {
    const headerStickyWrapper = document.querySelector('.header__area')
    const headerStickyTarget = document.querySelector('.header__sticky')

    if (headerStickyTarget) {
      let headerTop = 0
      let headerHeight = 0
      let lastScroll = window.scrollY
      let isSticky = headerStickyTarget.classList.contains('sticky')
      let resizeTimer

      // Re-anchoring the bar between flow and fixed is a reposition, not a
      // reveal, so it must not animate. Without this the stick point plays the
      // hide transition: `transform` goes 0 → -100% while the bar is newly
      // pinned to the viewport top, which reads as the header dropping into
      // view and immediately retreating.
      function withoutTransition(apply) {
        headerStickyTarget.style.transition = 'none'
        apply()
        void headerStickyTarget.offsetHeight
        headerStickyTarget.style.transition = ''
      }

      // `position: fixed` pulls the bar out of flow, so the wrapper collapses
      // by its height and the page jerks upward. Pinning the wrapper to its
      // natural height holds the gap open, so nothing below it moves.
      function setSticky(sticky) {
        if (sticky === isSticky) return

        headerStickyWrapper.style.height = sticky ? headerHeight + 'px' : ''
        headerStickyTarget.classList.toggle('sticky', sticky)
        isSticky = sticky
      }

      function setHidden(hidden) {
        headerStickyTarget.classList.toggle('header--hidden', hidden)
      }

      // Measure with the bar back in flow, then restore whatever state it was
      // in. Re-run after breakpoint changes and once the logo has loaded —
      // both change the header's height.
      function measure() {
        withoutTransition(function () {
          const wasSticky = isSticky

          setSticky(false)
          headerTop =
            headerStickyWrapper.getBoundingClientRect().top + window.scrollY
          headerHeight = headerStickyWrapper.offsetHeight
          setSticky(wasSticky)
        })
      }

      measure()

      window.addEventListener(
        'scroll',
        function () {
          const currentScroll = window.scrollY

          // Two thresholds, on purpose. The bar goes fixed only once it has
          // fully scrolled out, and returns to the flow only once its natural
          // slot is back under the viewport top. The band between them is
          // hysteresis: with a single threshold the state flipped exactly
          // where the bar was drawn, so any small scroll made it judder.
          if (!isSticky && currentScroll >= headerTop + headerHeight) {
            // Fix it now but leave it hidden, so a later scroll up has a start
            // position to slide down from.
            withoutTransition(function () {
              setHidden(true)
              setSticky(true)
            })
          } else if (isSticky && currentScroll <= headerTop) {
            // Releasing it here lands the bar exactly where it is already
            // painted, so the handover is invisible.
            withoutTransition(function () {
              setSticky(false)
              setHidden(false)
            })
          }

          // Direction only matters while fixed. Below the stick point the bar
          // is in the flow and simply scrolls away with the page.
          if (isSticky) {
            if (currentScroll < lastScroll - SCROLL_DELTA) {
              setHidden(false)
            } else if (currentScroll > lastScroll + SCROLL_DELTA) {
              setHidden(true)
            }
          }

          lastScroll = currentScroll
        },
        { passive: true }
      )

      window.addEventListener('load', measure)

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(measure, 150)
      })
    }
  }
  return ScrollSticky
})()
